import React, { useState,useEffect, useImperativeHandle, forwardRef } from "react";
import {
  Container,
  TextField,
  Typography,
  Grid,
  MenuItem,
  FormControl,
  Select,
  CircularProgress,
  InputLabel,
  FormHelperText,
  Button,useTheme
} from "@mui/material";
const CryptoJS = require('crypto-js');
const AppPersonalDetails= forwardRef(({ handleFieldChange, initialData }, ref) => {
   const theme = useTheme();
  const [formData, setFormData] = useState({
    FirstName: "",
    MiddleName: "",
    LastName: "",
    Legalname: "",
    PersonalMobileNumber: "",
    Personal_EmailID: "",
    corporate_email_id: "",
    BloodGroup: "",
    gender: "",
    date_of_birth: "",
    marital_status: "",
    languages_known: "",
    joining_date: "",
    tshirt_size: "",
    resignation_date: "",
    releaving_date: "",
    job_title_id: 0,
    probationary_period: 0,
    branch_id: 0,
    employeeType: "",
    isAdmin: "",
    designation: "",
    status: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const requiredFields = [
    "FirstName",
    "LastName",
    "MiddleName",
    "Legalname",
    "Personal_EmailID",
    "corporate_email_id",
    "PersonalMobileNumber",
    "gender",
    "date_of_birth",
    "joining_date",
    "designation",
    "employeeType",
    "status",
  ];

  useEffect(() => {
    if (initialData) {
      setFormData((prev) => ({ ...prev, ...initialData }));
    }
  }, [initialData]);

  const formatDate = (date) => {
    if (!date) return "";
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return new Date(date).toLocaleDateString("en-GB", options).replace(/ /g, "-");
  };
  const handleChange = async (event) => {
    const { name, value } = event.target;
     const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;
    let formattedValue = value;
    if (name.includes("date")) {
      formattedValue = formatDate(value);
    }
  
  
    setFormData({ ...formData, [name]: formattedValue });
    handleFieldChange("personalDetails", name, value); // Update parent state
    
    localStorage.setItem("tabemail", JSON.stringify({ Value: formattedValue }));

    localStorage.getItem("tabemail")


    setErrors({ ...errors, [name]: "" });
  
    // If typing corporate email, update backend & fetch latest one
    if (name === "corporate_email_id") {
 
 
  
      try {
        // Store the latest typed corporate email in the backend
        await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/set-recent-corporate-email`, {
          method: "POST",
          headers: { "Content-Type": "application/json" ,'Authorization': `Bearer ${accessToken}`},
          body: JSON.stringify({ corporate_email_id: formattedValue }),
        });
  
       
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/get-recent-corporate-email`, {
          method: "GET",
          headers: { "Content-Type": "application/json",'Authorization': `Bearer ${accessToken}` },
        });
  
        if (response.ok) {
          const data = await response.json();
  
          setFormData((prev) => ({ ...prev, corporate_email_id: data.corporate_email_id || formattedValue }));
        } else {
          console.error("Failed to fetch corporate email, Response not OK");
        }
      } catch (error) {
        console.error("Error fetching corporate email:", error);
      }
    }
  };
  
  
  const validateForm = () => {
    let newErrors = {};

    // Check required fields
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.replace(/_/g, " ")} is required`;
      }
    });

    // Validate Name Fields (Only Letters)
    ["FirstName", "MiddleName", "LastName", "Legalname"].forEach((field) => {
      if (formData[field] && !/^[A-Za-z\s]+$/.test(formData[field])) {
        newErrors[field] = `${field.replace(/_/g, " ")} must contain only letters`;
      }
    });

    // Mobile Number Validation (10 Digits)
    if (
      formData.PersonalMobileNumber &&
      !/^\d{10}$/.test(formData.PersonalMobileNumber)
    ) {
      newErrors.PersonalMobileNumber = "Mobile number must be 10 digits";
    }

    // Email Validation
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (
      formData.Personal_EmailID &&
      !emailRegex.test(formData.Personal_EmailID)
    ) {
      newErrors.Personal_EmailID = "Invalid email format";
    }
    if (
      formData.corporate_email_id &&
      !emailRegex.test(formData.corporate_email_id)
    ) {
      newErrors.corporate_email_id = "Invalid corporate email format";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Returns true if no errors
  };
  const handleSubmit = async () => {
    if (!validateForm()) {
      return false; // Stop saving if validation fails
    }
    
    setLoading(true);
    try {
      const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/add-personal-details`, {
        method: "POST",
        headers: { "Content-Type": "application/json",'Authorization': `Bearer ${accessToken}` },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        return true; // Indicate success
      } else {
        console.error("Error saving personal details");
        return false;
      }
    } catch (error) {
      console.error("Error:", error);
      return false;
    } finally {
      setLoading(false);
    }
  };

  useImperativeHandle(ref, () => ({
    handleSubmit,
  }));
  return (
    <Container maxWidth="md" sx={{ mt: 4, p: 3, borderRadius: 2 }}>
      <Typography variant="h5" align="center" gutterBottom>
        Add Employee - Personal Details
      </Typography>
      {loading && <CircularProgress sx={{ display: "block", mx: "auto", mb: 2 }} />}

      <form >
        <Grid container spacing={2}>
          {Object.entries(formData).map(([field, value]) => (
            <Grid item xs={12} sm={6} key={field}>
              {["gender", "marital_status", "employeeType", "designation", "isAdmin", "status"].includes(field) ? (
              // <FormControl fullWidth error={!!errors[field]}>
              //   <InputLabel>{field.replace(/_/g, " ")}</InputLabel>
                <FormControl fullWidth error={!!errors[field]} required={requiredFields.includes(field)}  sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                    backgroundColor: theme.palette.mode === "dark" ? "" : theme.palette.background.default,
                    color: theme.palette.text.primary,
              
                   
                    "&.Mui-focused fieldset": {
                      borderColor: theme.palette.mode === "dark" ? "white" : theme.palette.background.default,
                    },
                  },
                
                }}>
                <TextField
              select
              fullWidth
              label={field.replace(/_/g, " ")}
              name={field}
              value={value}
              onChange={handleChange}
              required={requiredFields.includes(field)}
              error={!!errors[field]}
              helperText={errors[field] || ""}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
                sx: {
                  color: theme.palette.mode === "dark" ? "#fff" : "inherit",
                  "&.Mui-focused": {
                    color: theme.palette.mode === "dark" ? "#fff" : theme.palette.primary.main,
                  },
                },
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                  backgroundColor: theme.palette.mode === "dark" ? "" : theme.palette.background.default,
                  color: theme.palette.text.primary,
                  "&.Mui-focused": {
                    backgroundColor: theme.palette.mode === "dark" ? "hsla(180, 17.20%, 25.10%, 0.92)" : "#f5f5f5",
                  },
                  "& fieldset": {
                    borderColor: theme.palette.mode === "dark" ? "grey" : "#ccc",
                  },
                  "&:hover fieldset": {
                    borderColor: theme.palette.primary.main,
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: theme.palette.mode === "dark" ? "white" : "black",
                  },
                },
                "& .MuiInputBase-input": {
                  color: theme.palette.text.primary,
                },
              }}
            >
              <MenuItem value="">Select {field.replace(/_/g, " ")}</MenuItem>
              {field === "gender" && [
                <MenuItem key="Male" value="Male">Male</MenuItem>,
                <MenuItem key="Female" value="Female">Female</MenuItem>,
              ]}
              {field === "marital_status" && [
                <MenuItem key="Single" value="Single">Single</MenuItem>,
                <MenuItem key="Married" value="Married">Married</MenuItem>,
              ]}
              {field === "employeeType" && [
                <MenuItem value="Trainee">Trainee</MenuItem>,
                <MenuItem value="Contractor">Contractor</MenuItem>,
                <MenuItem value="Employee">Employee</MenuItem>,
              ]}
              {field === "designation" && [
                <MenuItem value="Software Engineer">Software Engineer</MenuItem>,
                <MenuItem value="Senior Engineer">Senior Engineer</MenuItem>,
                <MenuItem value="DevOps Engineer">DevOps Engineer</MenuItem>,
                <MenuItem value="Full Stack Developer">Full Stack Developer</MenuItem>,
                <MenuItem value="Team Lead">Team Lead</MenuItem>,
                <MenuItem value="HR Manager">HR Manager</MenuItem>,
                <MenuItem value="Director">Director</MenuItem>,
                <MenuItem value="Intern">Intern</MenuItem>,
              ]}
              {field === "status" && [
                <MenuItem value="Active">Active</MenuItem>,
                <MenuItem value="Inactive">Inactive</MenuItem>,
                <MenuItem value="Resigned">Resigned</MenuItem>,
                <MenuItem value="On Leave">On Leave</MenuItem>,
              ]}
              {field === "isAdmin" && [
                <MenuItem key="true" value="true">Yes</MenuItem>,
                <MenuItem key="false" value="false">No</MenuItem>,
              ]}
            </TextField>

                {errors[field] && <FormHelperText>{errors[field]}</FormHelperText>}
              </FormControl>
            ) : (
              <TextField
                fullWidth
                label={field.replace(/_/g, " ")}
                name={field}
                type="text"
                value={formData[field]}
                onChange={handleChange}
                variant="outlined"
                required={requiredFields.includes(field)}  // Mark required fields
                InputLabelProps={{
                  shrink: true,
                  sx: {
                    //fontSize: '1.1rem',
                    color: theme.palette.mode === "dark" ? "#fff" : "inherit",
                    "&.Mui-focused": {
                      color: theme.palette.mode === "dark" ? "#fff" : theme.palette.primary.main,
                    },
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                    backgroundColor:
                      theme.palette.mode === "dark" ? "" : theme.palette.background.default,
                    color: theme.palette.text.primary,

                    // Active (focused) background color change
                    "&.Mui-focused": {
                      backgroundColor: theme.palette.mode === "dark" ? "hsla(180, 17.20%, 25.10%, 0.92)" : "#f5f5f5",
                      
                    },

                    "& fieldset": {
                      borderColor:
                        theme.palette.mode === "dark"
                          ? ""
                          : "#ccc",
                    },
                    "&:hover fieldset": {
                      borderColor: theme.palette.primary.main,
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: theme.palette.mode === "dark" ? "white" : "#f5f5f5",
                    },
                  },
                  "& .MuiInputBase-input": {
                    color: theme.palette.text.primary,
                  },
                }}
                error={!!errors[field]}
                helperText={errors[field] || ""}
              />
            )}

            </Grid>
          ))}
        </Grid>

      </form>
    </Container>
  );
});

export default AppPersonalDetails;
